module.exports = __webpack_public_path__ + "static/media/big-data.f1f2b397.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/categories/big-data.png
// module id = 484
// module chunks = 0